<template>
  <div>
    <v-row>
      <span v-show="false">{{ title }}</span>
      <v-col cols="12" md="6">
        <total-buy-of-month-chart></total-buy-of-month-chart>
      </v-col>
      <v-col cols="12" md="6">
        <total-sell-of-month-chart></total-sell-of-month-chart>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <total-buy-and-sell-of-month-chart></total-buy-and-sell-of-month-chart>
      </v-col>
      <v-col cols="12" md="6">
        <amount-inventory></amount-inventory>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <total-adjustment-goods-chart adjustment_type="ia"></total-adjustment-goods-chart>
      </v-col>
      <v-col cols="12" md="6">
        <total-adjustment-goods-chart adjustment_type="oa"></total-adjustment-goods-chart>
      </v-col>
      <v-col cols="12" :md="(financialYear.warehouse_system == 'a')?6:12">
        <order-point-table report_type="orderPoint"></order-point-table>
      </v-col>
      <v-col cols="12" md="6" v-if="financialYear.warehouse_system == 'a'">
        <order-point-table report_type="minusReport"></order-point-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>

import TotalBuyOfMonthChart from "@/views/modulePages/wareHouseModule/TotalBuyOfMonthChart";
import TotalSellOfMonthChart from "@/views/modulePages/wareHouseModule/TotalSellOfMonthChart";
import TotalBuyAndSellOfMonthChart from "@/views/modulePages/wareHouseModule/TotalBuyAndSellOfMonthChart";
import AmountInventory from "@/views/modulePages/wareHouseModule/AmountInventoryChart";
import TotalAdjustmentGoodsChart from "@/views/modulePages/wareHouseModule/TotalAdjustmentGoodsChart";
import OrderPointTable from "@/views/modulePages/wareHouseModule/OrderPointTable";

export default {
  name: "WareHouseHome",
  components: {
    OrderPointTable,
    TotalAdjustmentGoodsChart,
    AmountInventory,
    TotalBuyAndSellOfMonthChart,
    TotalSellOfMonthChart,
    TotalBuyOfMonthChart
  },
  props: {
    id: {},
  },
  data() {
    return {}
  },
  computed: {
    title() {
      return this.setDocumentTitle('داشبورد انبارداری')
    }
  }


}
</script>

<style scoped lang="scss"></style>

